import fetch from '@/assets/js/axios.js'
import { ROLE_SERVICE_API, MENU_SERVICE_API, PERMISSION_SERVICE_API, ROLE_TEMPLATE_SERVICE_API } from './apis'
// -------------------------角色服务--------------------------------------------------

// 获取产品对应的统计任务列表
export function roleList (params) {
  return fetch({
    url: ROLE_SERVICE_API.ROLE_LIST,
    method: 'post',
    data: params
  })
}

/// 更新角色
export function roleUpdae (params) {
  return fetch({
    url: ROLE_SERVICE_API.ROLE,
    method: 'put',
    data: params
  })
}

/// 添加角色
export function roleAdd (params) {
  return fetch({
    url: ROLE_SERVICE_API.ROLE,
    method: 'post',
    data: params
  })
}
/// 指定角色的角色的信息
export function roleDetail (roleId) {
  return fetch({
    url: ROLE_SERVICE_API.ROLE + `/${roleId}`,
    method: 'get'
  })
}

/// 删除角色
export function roleDel (params) {
  return fetch({
    url: ROLE_SERVICE_API.ROLE + '/' + params.roleId,
    method: 'DELETE'
  })
}
// 角色绑定菜单列表(去掉了老接口)
export function bindMenu (params) {
  return fetch({
    url: ROLE_SERVICE_API.BIND_MENU,
    method: 'post',
    data: params
  })
}

// 角色分配权限
export function bindAccess (params) {
  return fetch({
    url: ROLE_SERVICE_API.BIND_ACCESS,
    method: 'post',
    data: params
  })
}

// ------------------------角色模板服务-----------------------------------
// 修改角色模板
export function updateRoleTemplate (params) {
  return fetch({
    url: ROLE_TEMPLATE_SERVICE_API.ROLE_TEMPLATE,
    method: 'put',
    data: params
  })
}
// 删除
export function delRoleTemplate (id) {
  return fetch({
    url: ROLE_TEMPLATE_SERVICE_API.ROLE_TEMPLATE + `/${id}`,
    method: 'delete'
  })
}

// 新增角色模板
export function addRoleTemplate (params) {
  return fetch({
    url: ROLE_TEMPLATE_SERVICE_API.ROLE_TEMPLATE,
    method: 'post',
    data: params
  })
}

// 获取指定角色模板信息
export function viewRoleTemplate (id) {
  return fetch({
    url: ROLE_TEMPLATE_SERVICE_API.ROLE_TEMPLATE + `/${id}`,
    method: 'get'
  })
}

// 角色模板列表
export function roleTemplateList (params) {
  return fetch({
    url: ROLE_TEMPLATE_SERVICE_API.TEMPLATE_LIST,
    method: 'post',
    data: params
  })
}

// ------------------------授权服务-----------------------------------
/// 授权列表
export function rightAccessList () {
  return fetch({
    url: PERMISSION_SERVICE_API.RIGHT_ACCESS_LIST,
    method: 'post'
  })
}
// ---------------------------------------菜单服务-------------------------------

/// 菜单列表
export function menuList (params) {
  return fetch({
    url: MENU_SERVICE_API.MENU_LIST,
    method: 'post',
    data: params
  })
}

/// 获取用户对应的菜单列表
export function listOwnerMenu () {
  return fetch({
    url: MENU_SERVICE_API.OWNER_MENU_LIST,
    method: 'get'
  })
}

/// 获取指定菜单
export function rightMenuList (id) {
  return fetch({
    url: MENU_SERVICE_API.RIGHT_MENU + '/' + id,
    method: 'post'
  })
}

/// 新增菜单
export function addMenu (params) {
  return fetch({
    url: MENU_SERVICE_API.RIGHT_MENU,
    method: 'post',
    data: params
  })
}
/// 为菜单分配权限
export function menuBindAccess (params) {
  return fetch({
    url: MENU_SERVICE_API.MENU_BIND_ACCESS,
    method: 'post',
    data: params
  })
}

/// 获取指定角色菜单+按钮
export function getMenuListByRoleId (id) {
  return fetch({
    url: MENU_SERVICE_API.MENU_BY_ROLE_ID + `?roleId=${id}`,
    method: 'get'
  })
}
